declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function gtagReportConversion(event?: string): void {
  const eventName = event ?? 'initiate_checkout';
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName });
}

export {};
